import { useMemo } from 'react';
import {
  canvasTapeNewFiltersFamily,
  canvasTapeActiveCustomFilterFamily,
  canvasTapeSavedFiltersFamily,
  canvasTapeFlowLiveFamily,
  canvasTapeColumnVisibilityFamily,
  canvasTapeColumnSortModelFamily,
  canvasTapeColumnOrderFamily,
  canvasTapeColumnSizesFamily,
  canvasTapeFilterActiveTabFamily,
  canvasTapeFilterPanelOpenFamily,
  canvasTapeActiveWatchlistIdsFamily,
  canvasTapeContractsVisibilityFamily,
  canvasTapeContractsSortModelFamily,
  canvasTapeContractsColumnOrderFamily,
  canvasTapeContractsColumnSizesFamily,
} from 'states/canvasTape';

/**
 * Returns instance-scoped Recoil atoms for a Canvas Tape component.
 * Each component ID gets its own independent set of atoms.
 */
export function useTapeCanvasAtoms(componentId: number) {
  return useMemo(
    () => ({
      newFilterItemsState: canvasTapeNewFiltersFamily(componentId),
      activeCustomFilterState: canvasTapeActiveCustomFilterFamily(componentId),
      savedFiltersState: canvasTapeSavedFiltersFamily(componentId),
      tnsFlowLiveState: canvasTapeFlowLiveFamily(componentId),
      columnVisibilityState: canvasTapeColumnVisibilityFamily(componentId),
      columnSortModel: canvasTapeColumnSortModelFamily(componentId),
      columnOrderState: canvasTapeColumnOrderFamily(componentId),
      columnSizingState: canvasTapeColumnSizesFamily(componentId),
      filterActiveTabState: canvasTapeFilterActiveTabFamily(componentId),
      filterPanelOpenState: canvasTapeFilterPanelOpenFamily(componentId),
      activeWatchlistIdsState: canvasTapeActiveWatchlistIdsFamily(componentId),
      contractsColumnVisibilityState:
        canvasTapeContractsVisibilityFamily(componentId),
      contractsSortModelState: canvasTapeContractsSortModelFamily(componentId),
      contractsColumnOrderState:
        canvasTapeContractsColumnOrderFamily(componentId),
      contractsColumnSizingState:
        canvasTapeContractsColumnSizesFamily(componentId),
    }),
    [componentId],
  );
}
